import apiCaller from "./axios.service";

const baseUrl: string = "/v1/public/chat";

export const initChat = async <T>({
	identifier,
}: {
	identifier: string;
}): Promise<T> => {
	return apiCaller(`${baseUrl}/initChat`, {
		identifier,
	});
};

export const getAllMessageByIdentifier = async <T>({
	identifier,
	afterId,
	beforeId,
}: {
	identifier: string;
	afterId?: number;
	beforeId?: number;
}): Promise<T> => {
	return apiCaller(`${baseUrl}/getAllMessage`, {
		identifier,
		afterId,
		beforeId,
	});
};

export interface SendPublicMessagePayload {
	identifier: string;
	content?: string;
	contentAttributes?: {
		s3Key?: string;
	};
}

export const sendMessageByIdentifier = async <T>({
	identifier,
	content,
	contentAttributes,
}: SendPublicMessagePayload): Promise<T> => {
	return apiCaller(`${baseUrl}/sendMessage`, {
		identifier,
		...(content && { content }),
		...(contentAttributes && { contentAttributes }),
	});
};

export const generateChatSTSToken = () => {
	return apiCaller(`${baseUrl}/generateSTSToken`);
};
